import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Divider, Grid, Link } from '@mui/material';
import { AccountRating, AccountType, AccountIndustry, AccountOwnership } from '../../../../utils/enums'
import { format } from 'date-fns';

const FullDetails = ({ data }) => {
    return (
        <Accordion elevation={0} sx={{ borderRadius: '4px', '&:before': { height: '0px' } }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ margin: 0 }}>

                <h4>Details</h4>

            </AccordionSummary>
            <AccordionDetails
                sx={{ marginTop: '-17px' }}>
                <Divider />
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Account Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>

                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Account Owner</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Account Name</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.accountName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>AccountSite</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.accountSite || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Fax</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.fax || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Website</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.website || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Account Number</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.accountNumber || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Account Type</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.accountType ? AccountType[data?.accountType].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Industry</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.industry ? AccountIndustry[data?.industry].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Annual Revenue</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.annualRevenue || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Created By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}<br />{data?.createdAt ? format(new Date(data.createdAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                        </Grid>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Rating</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.rating ? AccountRating[data?.rating].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Phone</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.phone || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Parent Account</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.parentAccount || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Ticker Symbol</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.tickerSymbol || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Ownership</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownership ? AccountOwnership[data?.ownership].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Employees</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.employees || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>SIC Code</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.sicCode || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Modified By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}<br />{data?.updatedAt ? format(new Date(data.updatedAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>

                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Address Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Billing Street</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.billingStreet || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Billing City</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.billingCity || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Billing State</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.billingState || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Billing Code</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.billingCode || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Billing Country</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.billingCountry || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Shipping Street</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.shippingStreet || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Shipping City</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.shippingCity || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Shipping State</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.shippingState || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Shipping Code</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.shippingCode || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Shipping Country</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.shippingCountry || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Description Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Description</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.description || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default FullDetails;